import React ,{Component} from 'react'; 
import { Navigate  } from 'react-router-dom';
import axios from 'axios'; 
import Table from '@mui/material/Table';
import Serverurl from './Apiurl';
import Button from '@mui/material/Button';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow'; 
import { makeStyles } from '@mui/styles'; 
import Paper from '@mui/material/Paper';  
import TableSortLabel from '@mui/material/TableSortLabel';
import TableBody from '@mui/material/TableBody'; 
import TableCell from '@mui/material/TableCell';  
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';  
import TablePagination from '@mui/material/TablePagination'; 
import Box from '@mui/material/Box';
import TextField from '@mui/material/TextField';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import AddBoxRoundedIcon from '@mui/icons-material/AddBoxRounded';
import FormControl from '@mui/material/FormControl';
import Collapse from '@mui/material/Collapse';
import CloseIcon from '@mui/icons-material/Close';
import Alert from '@mui/material/Alert';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';
import pageimg from './images/attendance.png';



const headCells = [


 
  
  { id: 'br_title', numeric: false, label: 'Title' },
  { id: 'br_address', numeric: false, label: 'Address' },
  { id: 'br_contactnumber', numeric: false, label: 'Phone No.' },
   { id: 'trust', numeric: false, label: 'Trust' },
   { id: '',  label: '' },
  ]
  function stableSort(array, cmp) {
	  const stabilizedThis = array.map((el, index) => [el, index]);
	  stabilizedThis.sort((a, b) => {
		const order = cmp(a[0], b[0]);
		if (order !== 0) return order;
		return a[1] - b[1];
	  });
	  return stabilizedThis.map(el => el[0]);
}
function desc(a, b, orderBy) {
	  if (b[orderBy] < a[orderBy]) {
		return -1;
	  }
	  if (b[orderBy] > a[orderBy]) {
		return 1;
	  }
	  return 0;
}
function getSorting(order, orderBy) {
	return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
}

function EnhancedTableHead(props) {
  const { classes,  order, orderBy,  rowCount, onRequestSort } = props;
  const createSortHandler = property => event => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        
        {headCells.map(headCell => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'right' : 'left'}
            padding={headCell.disablePadding ? 'none' : 'default'}
            sortDirection={orderBy === headCell.id ? order : false}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <span className={useStyles.visuallyHidden}>
                  {order === 'desc' ? ' ' : ' '}
                </span>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  classes: PropTypes.object.isRequired,
 
  onRequestSort: PropTypes.func.isRequired,
 
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};
const useToolbarStyles = makeStyles(theme => ({
  root: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
  },
  
  
  title: {
    flex: '1 1 100%',
  },
}));

const EnhancedTableToolbar = props => {
  const classes = useToolbarStyles();
  const { numSelected } = props;

  };

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};


const useStyles = makeStyles({  
  root: {  
    width: '100%',  
  },  
  container: {  
    maxHeight: 440,  
  }, 
 icon: {
   verticalalign:'middle',
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },  
});


export default class Branchmaster extends Component {
	
    constructor(props) {
    super(props);
   
      this.state = {redirect: false,
      Branchdata:[],brid:'',page: 0 ,prevpage:0,totaldata:0,rowsPerPage:50,rowsPaging:[],
	 
	  order:'desc' ,orderBy:'',titles:'',syllabus:'',trustarray:[],trust:'',rolelabel:'Select Trust',searchcustomer:'',
	          
      }
       this.updateDonenewParent = this.updateDonenewParent;
	   
	}
	
	updateDonenewParent = (text) => {this.componentDidMount();  }
	
	Search(){
	this.setState({  
      page: 0,
      rowsPerPage:50,
	  prevpage:0,Branchdata:[]
    });
	
//this.componentDidMount();  
}
	
componentDidUpdate() {
	
  if(this.state.prevpage !== this.state.page) {
    this.setState({   prevpage: this.state.page});
  this.apicall(this.state.page, localStorage.getItem("page"));  
  }
}

	componentWillMount() { 
localStorage.setItem("pageactive",3)
}


	componentDidMount() {
	


	 
		
	
	
	document.title = "MM Coching Center - Batch Management";
	
	if(localStorage.getItem("MMCuserid")==null)
		  {

		   this.setState({
            redirect: true,
			pagename:'/Login'
          })
		  }
	
	
	
	  localStorage.setItem("page",this.state.rowsPerPage)
  this.apicall(this.state.page,this.state.rowsPerPage);
  this.onloadtrustbind();
} 


 onloadtrustbind(){

    axios.get(Serverurl+'ajaxtrustandclass.php?action=getall&tc_type=1')
	
    
      .then((response) => {    
     
      this.setState({  trustarray: response.data,  });
      })   
    
      .then(data => {
        let roleFromApi = this.state.trustarray.map(trust => {
                            
          return {value: trust.tc_id, display:trust.tc_title}
        });
      
		
        this.setState({
          trustarray: [{value: '', display: 'Select Trust'}].concat(roleFromApi)
        });
      })


} 


handleClickSearch=()=>{   
 
  
  this.apicall(this.state.page,this.state.rowsPerPage); 

	
} 

myChangeHandler = (event) => {
  let nam = event.target.name;
  let val = event.target.value;
  this.setState({[nam]: val});
 
}

apicall(page,rowsPerPage){
	 
	 axios.get(Serverurl+'ajaxbranch.php?action=getall&br_title='+this.state.titles+'&br_trust_id='+this.state.trust+'&StartIndex='+page+'&PageSize='+rowsPerPage)
     
	
  .then(resp => {  
		
    if(resp.data.length>0){
		
			this.setState({  
			  Branchdata: resp.data,  
			   totaldata:parseInt(resp.data[0].count),
			   

		    });
		
			
			let copy=[50, 100, 150, 200, 250];
			
	  
	  this.setState({rowsPaging:copy});
	 
     }
	 else{
		   this.setState({Branchdata:[],totaldata:0});
	 }
 
    });
}





handleChangePage = (event, newPage) => {  
   
    let pageval = localStorage.getItem("page");
    this.setState({  
      page: newPage,
      rowsPerPage:parseInt(pageval)
    });
   
 
    setTimeout(() =>  this.componentDidUpdate() ,500); 
  };  
  
  
   handleChangeRowsPerPage = event => {  
  
    let pageval = event.target.value;
    localStorage.setItem("page",pageval)

    setTimeout(() =>  this.componentDidUpdate() ,500);
    this.setState({  
      page: 0,
      rowsPerPage:parseInt(pageval),
	  prevpage:-1
    }); 
	
	
  }; 
  
  
  handleRequestSort = (event, property) => {
  const isAsc = this.state.orderBy === property && this.state.order === 'asc';
  

  this.setState({   orderBy: property,
    order:isAsc  ? 'desc' : 'asc'
   
  });
};


      branchDelete(brid){  
	
let r = window.confirm("Do you really want to Delete?");
 if(r == true){ //sign Out logic
 var formData = new FormData();
     formData.append('action','delete')
	 formData.append('br_id',brid)
	 	   
	formData.append('userid',localStorage.getItem("MMCuserid"))
	
	
	 axios.post(Serverurl+"ajaxbranch.php", formData, {
        }).then(res => {
    
             this.setState({  
      prevpage: -1,
    
    });
   
 
    setTimeout(() =>  this.componentDidUpdate() ,500); 
  
    
            });
 }
      }
      Branchaddbox(val){
        this.setState({ brid: val });  
  
         setTimeout(() => this.refs.AddBranchbox.handleClickOpen(),500);

      }

render() {

if (this.state.redirect === true) {
      return <Navigate to={this.state.pagename} />
    }


  return (
  
  
  



 
  <React.Fragment>
   
<div className="containermain">
<div className="boxheading">
				  <div className="contntpad">
<h2><img src={pageimg}/>Branch Management</h2>
</div></div>

   <div className="searchmaster">


  
  <ul>
  
 <li>
 <p ><TextField
            variant="outlined"
            margin="normal"
            fullWidth value={this.state.titles}
           inputProps={{tabIndex: "1",maxLength:150}}
			placeholder="Title"
            name="titles" onChange={this.myChangeHandler}
		
          /></p></li>
		
		
			<li><p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth
		 
		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.rolelabel, value: this.state.trust }}
          onChange={this.myChangeHandler}
          id="trust"
		   value={this.state.trust}
		  name="trust"
		
		
        >
		{this.state.trustarray.map(trust => (
            <option  
            
              value={trust.value}
            >
              {trust.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p>
	
			  </li>
	
	
		
		<li><p >
		<Button variant="contained" onClick={this.handleClickSearch} className="frmPrimarybtn" endIcon={<SearchIcon />}>
        Search
      </Button>&nbsp;
	  <Button variant="contained" onClick={()=>{this.Branchaddbox(0)}} className="frmsecondarybtn" endIcon={<AddIcon />}>
        New
      </Button></p></li> 
		
		
		
		
		</ul>
		
</div>		



<AddBranchbox ref="AddBranchbox" id={this.state.brid}  updateDonenew={this.updateDonenewParent}/>
<Paper className={useStyles.root}>


  <TableContainer className={useStyles.container}>  
                <Table stickyHeader aria-label="sticky table">  
<TableHead> 
<TableRow>
                                              
                       
						
                      </TableRow></TableHead>
					  
					   <EnhancedTableHead           
              order={this.state.order}
              orderBy={this.state.orderBy}
              
              onRequestSort={this.handleRequestSort}
              rowCount={this.state.Branchdata.length}
            />
                      <TableBody>
                     {stableSort(this.state.Branchdata, 
			getSorting(this.state.order,
			this.state.orderBy)).map((item,index) => {  
           return (
 <React.Fragment>
 <TableRow key={index} >



<TableCell>{item.br_title}</TableCell>
<TableCell>{item.br_address}</TableCell>
<TableCell>{item.br_contactnumber}</TableCell>
<TableCell>{item.tc_title}</TableCell>
<TableCell align="left">
<div className="actionbtns">



<Button variant="contained" className="frmPrimarybtn" onClick={()=>{this.Branchaddbox(item.br_id)}} endIcon={<EditIcon />}>
Edit
</Button>

{item.brnchcnt==="0" && (

<Button variant="contained" className="admsndisablebtn" onClick={()=>{this.branchDelete(item.br_id)}} endIcon={<DeleteIcon />}>
  Delete
</Button>
)}
 


 </div>
 
 </TableCell>
 </TableRow>

 </React.Fragment>	
);
					})}
					
					{this.state.totaldata===0 &&(
					
					<TableRow key={0} >
<TableCell align="center" colSpan="4">No Records</TableCell>
					</TableRow>
					) }
					
                      </TableBody>


</Table>
  </TableContainer> 
  <TablePagination  
        rowsPerPageOptions={[50, 100, 150, 200, 250]}  
        component="div"  
        count={this.state.totaldata}  
        rowsPerPage={this.state.rowsPerPage}  
        page={this.state.page}  
        onPageChange={this.handleChangePage}  
        onChangeRowsPerPage={this.handleChangeRowsPerPage}  
      />   
  </Paper>
    
</div>
 </React.Fragment> 

 
 
  );
}
}


export  class  AddBranchbox extends Component {

   constructor(props) {
      super(props)
	  
      this.state = {
		  
		   open:false,title:'',br_id:0,trustarray:[],trust:'',rolelabel:'Select Trust',contactnumber:'',address:'',
      errormessage:'',erropen:false,
	  }
      
  }
  
  
  
 onloadTrustbind(){

    axios.get(Serverurl+'ajaxtrustandclass.php?action=getall&tc_type=1')
	
    
      .then((response) => {    
     
      this.setState({  trustarray: response.data,  });
      })   
    
      .then(data => {
        let roleFromApi = this.state.trustarray.map(trust => {
                            
          return {value: trust.tc_id, display:trust.tc_title}
        });
      
		
        this.setState({
          trustarray: [{value: '0', display: 'Select Trust'}].concat(roleFromApi)
        });
      })
  
  
  }
  
  
 Branchgetdata() {
	
  if(this.props.id!==0)
  {
	  
	   axios.get(Serverurl+'ajaxbranch.php?action=getall&br_id='+this.props.id)
  .then(resp => {  
		
    if(resp.data.length>0){
    this.setState({ 
     
      br_id:resp.data[0].br_id,
	  title: resp.data[0].br_title,
      address: resp.data[0].br_address, 
contactnumber: resp.data[0].br_contactnumber, 
    trust: resp.data[0].br_trust_id,  
      
    
    });
	
  }
  
});
	  
  }else{
	 this.setState({  
	  title:'',
	 
	 address:'',
	 contactnumber:'',
	 br_id:0,
	 trust:''
	 
	  }); 
 }
  
    }

   
handleClickOpen = (e) => {
 
  this.setState({open:!this.state.open,  title:'',address:'',contactnumber:'',trustarray:[],trust:'', 
     errormessage:'',erropen:false,
	  });
		this.Branchgetdata();
		this.onloadTrustbind();


};
myChangeHandler = (event) => {
	
	  const re = /^[0-9\b]+$/;
  let nam = event.target.name;
  let val = event.target.value;  
 
  if(nam==="contactnumber")
  {
	  if (event.target.value === '' || re.test(event.target.value)) {
	  this.setState({[nam]: val}); 
	  
  }
  }
  else{
  this.setState({[nam]: val});
  }
  

}

 handleErrorclose=(event)=>{
	  
	this.setState({open: false});  
  }


handleClose = (e) => {
	
	
 let title = this.state.title;
 let address = this.state.address;
 let contactnumber = this.state.contactnumber;
  let trust = this.state.trust;

if(title==="")
{
	
	this.setState({errormessage:"Please Enter Title",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}



if(contactnumber==="")
{
	
	this.setState({errormessage:"Please Enter Contact Number",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(trust==="")
{
	
	this.setState({errormessage:"Please Select Trust",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
if(address==="")
{
	
	this.setState({errormessage:"Please Enter Address ",erropen:true});
		 window.scrollTo({
          top: 0
      })
		 return false;
	
	
}
   var formData = new FormData();
  
  
   if(this.state.br_id==0)
	  {
		  formData.append('br_id',0) 
		  
	  }
	  else
	  {
		  
	   formData.append('br_id',this.state.br_id)
		
          }
	  
	  
	  
	  
	 
        formData.append('action','insertorupdate') 
		
		formData.append('br_title',title)
		formData.append('br_address',address)
		formData.append('br_contactnumber',contactnumber)
		formData.append('br_trust_id',trust)
		
		
		formData.append('userid',localStorage.getItem("MMCuserid"))
		  
		axios.post(Serverurl+"ajaxbranch.php", formData, {
        }).then(res => {
    
	
	
	if(res.data == -1)
{ 
	 

		this.setState({errormessage:"Title Already Exist.",erropen:true,open:true
		});
		window.scrollTo({
          top: 0
      })
		 return false;

	}
	
	
            this.props.updateDonenew();
    
        });
  
	
	this.setState({ open:false });
};

	 handleErrorclose=(event)=>{
	  
	this.setState({erropen: false});  
  } 

	


render (){

return(
<React.Fragment>





    <Dialog open={this.state.open} onClose={this.handleClose} maxWidth="xs" fullWidth="true" aria-labelledby="form-dialog-title">
      <DialogTitle id="form-dialog-title"> Branch Management</DialogTitle>
      <DialogContent>
	  
<div className="formlist">

	<p>  <Collapse in={this.state.erropen}>
        <Alert
          action={
            <IconButton
              aria-label="close"
              color="inherit"
              size="small"
              onClick={() => {
               this.handleErrorclose();
              }}
            >
              <CloseIcon fontSize="inherit" />
            </IconButton>
          } severity="error"
        >
        {this.state.errormessage}
        </Alert>
      </Collapse></p>
						  
						  
		
						  
	<p> <span className="validation">*</span> Title</p>
	
	<p><TextField name="title" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.title}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "1",maxLength:150}} 
	   InputLabelProps={{ shrink: true }}
                          /></p>	<p> <span className="validation">*</span> Contact Number</p>
	
	<p><TextField name="contactnumber" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   value={this.state.contactnumber}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "2",maxLength:13}} 
	   InputLabelProps={{ shrink: true }}
                          /></p>		<p> <span className="validation">*</span> Trust</p>
	

	
		<p><FormControl  className="stadrp">
         
        <Select
         native  fullWidth
		 
		 
		 variant="outlined"
            margin="normal"
		  defaultValue={{ label: this.state.rolelabel, value: this.state.trust }}
          onChange={this.myChangeHandler}
          id="trust"
		   value={this.state.trust}
		  name="trust"
		
		
        >
		{this.state.trustarray.map(trust => (
            <option  
            
              value={trust.value}
            >
              {trust.display}
            </option  >
          ))}
		
        </Select></FormControl>
		
				</p>
	
			 <p> <span className="validation">*</span> Address</p>
	
	<p><TextField name="address" 
	   onChange={this.myChangeHandler} 
	   fullWidth
	   multiline
          rows={4}
	   value={this.state.address}
			 
			  ref={this.usernameInput}
			  inputProps={{tabIndex: "4",maxLength:150}} 
	   InputLabelProps={{ shrink: true }}
                          /></p>
		
       <div className="actionbtns">
<div className="cancelbtn">	  
        <Button onClick={this.handleClickOpen} color="secondary">
          Cancel
        </Button></div> 
<div className="savebtn">
        <Button onClick={this.handleClose} color="secondary">
          Save
        </Button>
		</div>
<div className="clear"></div>

 </div>     
	</div>		 
						    </DialogContent>
      
    </Dialog>
</React.Fragment>

) }
 
} 
  